import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { exploreEtherData } from '../../../../Shared/ExploreDataFactory';

export interface IBidsProps {
}

export function Bids(props: IBidsProps) {
    const { pathname } = useLocation();
    const nftID = pathname.split("/")[2]

    const singleMatchGigData = exploreEtherData.find(data => data.id === JSON.parse(nftID!))

    return (
        <div className="mt-4 h-48 overflow-auto">

            {singleMatchGigData?.bids.map(bid =>
                <div className="flex justify-start items-center mb-4" key={bid.bidTitle}>
                    <div>
                        <div className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 rounded-full">
                            <img src={bid.bidLogo} alt="" className="w-full h-full" />
                        </div>
                    </div>

                    <div className="ml-2 sm:ml-3 md:ml-5 text-left">
                        <h4 className="xs:text-xxs sm:text-sm xl:text-base font-semibold dark:font-normal text-cusBlack dark:text-white ">{bid.bidTitle}</h4>
                        <p className="text-cusBlack dark:text-cusBlueWhite text-xxs sm:text-xs mt-1">{bid.time}</p>
                    </div>
                </div>
            )}

        </div>
    );
}
